import { initializeApp } from 'firebase/app';
import { getAuth, signInAnonymously, onAuthStateChanged, User } from 'firebase/auth';

// Your Firebase configuration
// Replace with your actual Firebase config
const firebaseConfig = {
  apiKey: "your-api-key",
  authDomain: "your-project.firebaseapp.com",
  projectId: "your-project-id",
  storageBucket: "your-project.appspot.com",
  messagingSenderId: "your-sender-id",
  appId: "your-app-id"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

// Enable anonymous authentication
auth.useDeviceLanguage();

export { auth, signInAnonymously, onAuthStateChanged };
export type { User };

// Helper function to get auth token for API calls
export const getAuthToken = async (): Promise<string | null> => {
  // For development, use test token instead of Firebase
  if (process.env.NODE_ENV === 'development') {
    return 'test-token';
  }
  
  const user = auth.currentUser;
  if (user) {
    try {
      const token = await user.getIdToken();
      return token;
    } catch (error) {
      console.error('Error getting auth token:', error);
      return null;
    }
  }
  return null;
};

